@if ((mail$ | async); as mail) {
  <div class="sh-contained-eml">
    <h3>{{'viewer.eml.subject' | translate }}: {{mail.subject}}</h3>
    @if (mail.html) {
      <div [innerHTML]="mail.html | safeHtml"></div>
    }
    @if (!mail.html) {
      <pre>{{mail?.text?.trim()}}</pre>
    }
  </div>
}
